import type { HistoricalConfigDeployment } from '@racepointenergy/swc/scs/read-config-home-home-history'
import { ConfigDeploymentState } from '@racepointenergy/swc/scs/read-config-home-home-history'
import {
  DownloadStatus,
  ErrorStatus,
  NewStatus,
  SuccessStatus,
} from 'components/Statuses'
import { createElement } from 'react'

type DeploymentStatusProps = Pick<
  HistoricalConfigDeployment,
  'date' | 'message' | 'progress' | 'state' | 'updated'
>

type StatusHash = {
  [State in ConfigDeploymentState]: (
    props: DeploymentStatusProps
  ) => JSX.Element
}

const statusHash: StatusHash = {
  DOWNLOAD: DownloadStatus,
  ERROR: ErrorStatus,
  NEW: NewStatus,
  SUCCESS: SuccessStatus,
}

const TEN_MINUTES = 1000 * 60 * 10

function DeploymentStatus({ progress, ...props }: DeploymentStatusProps) {
  let { message, state } = props
  const { updated } = props
  if (!state || typeof statusHash[state] !== 'function') {
    return null
  }

  const deploymentIsPending =
    state === ConfigDeploymentState.Download ||
    state === ConfigDeploymentState.New

  const deploymentIsStale = +Date.now() - updated >= TEN_MINUTES

  if (deploymentIsPending && deploymentIsStale) {
    message = `Error: ${message}`
    state = ConfigDeploymentState.Error
  }

  return createElement(statusHash[state], { ...props, message, state })
}

export default DeploymentStatus
